module.exports = __webpack_public_path__ + "static/media/search.da0a0b9e.svg";